// عنوان الدعم الفني — مصدر واحد لكل الشاشات.
// يُضبط REACT_APP_SUPPORT_EMAIL في: frontend/.env (التطوير)، deploy/scripts/build_restart.sh (الويب/AWS)،
// و workflows بناء Android و iOS. والعنوان الاحتياطي موجود لأن آبل (1.5) وGoogle Play تشترطان جهة اتصال
// دعم عاملة داخل التطبيق، فلا يجوز أن يظهر "undefined" إن غاب المتغيّر في أي مسار بناء جديد.
export const SUPPORT_EMAIL = process.env.REACT_APP_SUPPORT_EMAIL || "support@helcoo.uk";

export const supportMailto = (subject = "HELCOO Support") =>
  `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}`;
